module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.e18bbf6.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap/fonts/glyphicons-halflings-regular.ttf
// module id = 877
// module chunks = 3